import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/confluence': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M2.3 412.2C-2.2 419.8 0.2 429.7 7.8 434.4L113.7 499.6C121.4 504.3 131.4 502 136.1 494.3 136.1 494.2 136.2 494.1 136.2 494.1 203.3 381.9 216.7 398.2 417.1 493.4 425.2 497.3 434.9 493.8 438.8 485.7 438.9 485.6 438.9 485.4 439 485.3L489.4 371.2C493 363.1 489.3 353.6 481.3 349.9 459.1 339.5 415.1 318.7 375.4 299.6 127.5 179 44.6 345.3 2.3 412.2zM509.7 100.1C514.2 92.5 511.8 82.6 504.2 77.9L398.4 12.8C390.9 7.8 380.8 9.7 375.8 17.2 375.6 17.5 375.4 17.8 375.2 18.2 307.9 130.8 294.1 113.8 94.6 19.1 86.5 15.2 76.8 18.7 72.9 26.8 72.8 26.9 72.8 27.1 72.7 27.2L22.2 141.3C18.6 149.4 22.3 158.9 30.3 162.6 52.5 173 96.6 193.8 136.3 213 384.3 333 467.1 167.6 509.7 100.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/confluence.js
// module id = L6q5
// module chunks = 144